import { render, staticRenderFns } from "./SetTouchScreenPicture.vue?vue&type=template&id=794975f6&scoped=true"
import script from "./SetTouchScreenPicture.vue?vue&type=script&lang=js"
export * from "./SetTouchScreenPicture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794975f6",
  null
  
)

export default component.exports